import { render, staticRenderFns } from "./halfwxview.vue?vue&type=template&id=92eb79d8&scoped=true&"
import script from "./halfwxview.vue?vue&type=script&lang=js&"
export * from "./halfwxview.vue?vue&type=script&lang=js&"
import style0 from "./halfwxview.vue?vue&type=style&index=0&id=92eb79d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eb79d8",
  null
  
)

export default component.exports